import { Injectable } from '@angular/core';
import { CostAccountingRequestService } from '../services/cost-accounting-request.request.service';
import { Observable } from 'rxjs';
import { IMeasureUnit } from '../models/measure-unit.model';

const BASE_URL: string = 'measure-unit';

@Injectable({
    providedIn: 'root'
})
export class MeasureUnitResource {
    constructor(private myCostAccountingRequestService: CostAccountingRequestService) {
    }

    public getAllMeasureUnits(): Observable<IMeasureUnit[]> {
        return this.myCostAccountingRequestService.get(BASE_URL);
    }

    public createMeasureUnit(measureUnit: IMeasureUnit): Observable<IMeasureUnit> {
        return this.myCostAccountingRequestService.post(BASE_URL, measureUnit);
    }

    public updateMeasureUnit(measureUnit: IMeasureUnit): Observable<IMeasureUnit> {
        return this.myCostAccountingRequestService.put(`${BASE_URL}/${measureUnit.id}`, measureUnit);
    }

    public deleteMeasureUnit(measureUnitId: number): Observable<void> {
        return this.myCostAccountingRequestService.delete(`${BASE_URL}/${measureUnitId}`);
    }
}
